<dx-popup
  #importPopup
  [wrapperAttr]="{ class: 'sp-dx-normal-popup' }"
  contentTemplate="popup-content"
  [hideOnOutsideClick]="false"
  [showTitle]="true"
  title="Import membership levels"
  position="center"
  width="600"
  maxWidth="90%"
  height="auto"
  maxHeight="80vh"
  [dragEnabled]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.5)"
  [showCloseButton]="true"
  [deferRendering]="false"
  (onShown)="onPopupShown()"
>
  <div *dxTemplate="let data of 'popup-content'">
    <dx-scroll-view>
      <div class="modal-content-container">
        <form [formGroup]="formGroup">
          <p class="mb-2">Drop a CSV file on the area below, or click it to browse.</p>
          <div
            #importDropZone
            id="membershipLevelsImportDropZone"
            class="membership-import-drop-zone"
            [class.drop-zone-active]="isDropZoneActive"
            role="button"
            tabindex="0"
            (keydown.enter)="$event.preventDefault(); triggerBrowseClick()"
            (keydown.space)="$event.preventDefault(); triggerBrowseClick()"
          >
            <i class="fa-regular fa-cloud-arrow-up membership-import-drop-icon" aria-hidden="true"></i>
            <div class="membership-import-drop-text">
              <span class="fw-medium">Drop CSV here</span>
              <span class="text-muted"> or click to choose a file</span>
            </div>
          </div>
          <dx-file-uploader
            #dxFileUploader
            dialogTrigger="#membershipLevelsImportDropZone"
            dropZone="#membershipLevelsImportDropZone"
            [visible]="false"
            [multiple]="false"
            [allowedFileExtensions]="['.csv']"
            accept=".csv"
            [(value)]="dxFileUploadValue"
            uploadMode="useButtons"
            (onValueChanged)="onDxValueChanged($event)"
            (onDropZoneEnter)="onDropZoneEnter()"
            (onDropZoneLeave)="onDropZoneLeave()"
          >
          </dx-file-uploader>
          <div *ngIf="fileName" class="text-secondary small mt-2">Selected: {{ fileName }}</div>
        </form>
        <div class="margin-top-20 padding-20" style="background-color: rgba(0, 0, 0, 0.05)">
          <div class="margin-bottom-10">CSV must be formatted based on our template.</div>
          <div>
            <a [href]="csvTemplateUrl" download="membership-levels-import-template.csv">
              <span>Download CSV Template</span>
            </a>
          </div>
          <div class="margin-top-10 text-secondary font-light small">
            Required field: Name. Optional fields: Description, Dues, Number of Members (defaults: Due Frequency = Monthly, Status = Active).
          </div>
        </div>
        <div
          *ngIf="importErrors?.length"
          #importErrorsPanel
          class="margin-top-20 padding-20 membership-import-errors-panel"
        >
          <div class="fw-semibold margin-bottom-10 text-danger">Import issues</div>
          <ng-container *ngIf="importErrors.length === 1">
            <div class="small import-error-item">
              <span *ngIf="importErrors[0].source" class="fw-medium">{{ importErrors[0].source }}: </span>{{ importErrors[0].details }}
            </div>
          </ng-container>
          <ng-container *ngIf="importErrors.length > 1">
            <p class="small text-secondary margin-bottom-10 mb-2">
              There are some error rows that need to be fixed before import.
            </p>
            <button
              type="button"
              class="btn btn-link btn-sm p-0 membership-import-errors-toggle"
              (click)="toggleImportErrorsExpanded()"
              [attr.aria-expanded]="importErrorsExpanded"
            >
              {{ importErrorsExpanded ? 'Hide' : 'Show' }} row details ({{ importErrors.length }})
              <i class="fa-regular" [class.fa-chevron-down]="!importErrorsExpanded" [class.fa-chevron-up]="importErrorsExpanded" aria-hidden="true"></i>
            </button>
            <ul *ngIf="importErrorsExpanded" class="list-unstyled margin-0 margin-top-10 mt-2 mb-0">
              <li *ngFor="let err of importErrors" class="import-error-item small">
                <span *ngIf="err.source" class="fw-medium">{{ err.source }}: </span>{{ err.details }}
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
    </dx-scroll-view>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{ text: 'Cancel', type: 'normal', stylingMode: 'outlined', onClick: closePopup }"
  >
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      text: uploadInProgress ? 'Importing…' : 'Import',
      type: 'success',
      stylingMode: 'contained',
      onClick: dxUpload,
      disabled: !hasQueuedFileUpload || uploadInProgress,
    }"
  >
  </dxi-popup-toolbar-item>
</dx-popup>
